<template>
    <div class="uploaded-files-component">
        <p style="margin-bottom: 11px">If you want to withdraw your money you must verify your account. <span v-if="files.length <= 0">Please send us scan of your ID with your living address
            or ID and bill to confirm your living address. You have uploaded no files.</span></p>
        <b-row v-for="(file, index) in files"
               :key="index"
               class="one-file">
            <div class="file-row">
                <b-col lg="3">
                    <p>Upload files:</p>
                </b-col>
                <b-col lg="4">
                    <p>{{ datetime.utcToLocal(file.created_at) }}</p>
                </b-col>
            </div>
            <br>
            <div class="file-row">
                <b-col lg="3">
                    <p>Status:</p>
                </b-col>
                <b-col lg="4">
                    <p :class="{ 'status-success': file.status === 'accepted',
                                 'status-decline': file.status === 'declined',
                                 'status-new'    : file.status === 'new',}">{{ file.status }}</p>
                </b-col>
            </div>
            <br>
            <div class="file-row" v-if="file.reason">
                <b-col lg="3">
                    <p>Reason:</p>
                </b-col>
                <b-col lg="4">
                    <p :class="{ 'status-decline': file.status === 'declined' }">{{ file.reason }}</p>
                </b-col>
            </div>
        </b-row>
        <p v-if="files.length <= 0 && !loader"
           style="color: red">You have not uploaded any file yet.</p>
        <div class="data-loader" v-if="loader"></div>
        <image-modal :source="src"></image-modal>
    </div>
</template>

<script>
    import ImageModal from '../../../modals/ImageModal.vue'

    export default {
        components: { ImageModal },
        dependencies: ['datetime', 'verification'],
        data () {
            return {
                loader: true,
                src: ''
            }
        },
        computed: {
            files () {
                return this.$store.getters.verificationFiles
            }
        },
        methods: {
            showImage (source) {
                this.src = source
                this.$store.commit('modals', {
                    modal: 'image',
                    data: {
                        visible: true
                    }
                })
            }
        },
        mounted () {
            this.verification.loadVerificationFiles().then(() => {
                this.loader = false
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../../assets/scss/_colors.scss';

    .uploaded-files-component{
        margin-bottom: 22px;
    }

    .file-row{
        display: flex;
        width: 100%;
    }

    .one-file{
        +.one-file{
            margin-top: 22px;
        }
    }

    p{
        &.status-new{
            color: $base1;
        }

        &.status-decline{
            color: red;
        }

        &.status-success{
            color: green;
        }
    }

    .pointer{
        cursor: pointer;
    }

    .uploaded-files-list{
        li{
            display: inline-block;
            vertical-align: middle;
            margin-right: 6px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile/verification/UploadedFiles.vue